export function getPlacementTestStaticDescription(assetType: string): string {
  const descriptionMap: Record<string, string> = {
    PHOTO: 'Discover your level with a short test',
    VIDEO: 'Discover your level with a short test',
    AUDIO: 'Discover your level with a short test',
    DEFAULT: 'Discover your level with a short test',
  };

  const description = descriptionMap[assetType] || descriptionMap.DEFAULT;

  return description;
}
